module.exports = __webpack_public_path__ + "static/img/pic.ce7e0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/us/pic.png
// module id = bKTj
// module chunks = 1